import React, {CSSProperties} from 'react';

import {Button} from '@material-ui/core';
import {Plan} from 'grpc-bob/subscription_pb';

import styles from './PlanPicker.module.css';
import clsx from 'clsx';

interface PlanPickerProps {
  className?: string
  style?: CSSProperties
  plans: Array<Plan.AsObject>
  onChoosePlan: (planId: string) => void
}

const PlanPicker = (props: PlanPickerProps) => {

  const {
    className,
    style,
    plans,
    onChoosePlan
  } = props;

  return (
    <div className={clsx(styles.root, className)} style={style}>
      {
        plans.map((plan) => {

          if (plan.id === "Hub") return null;

          return (
            <Button
              key={plan.id}
              fullWidth
              variant="contained"
              className={styles.option}
              color="primary"
              onClick={() => onChoosePlan(plan.id)}
            >
              {plan.id}
            </Button>
          );
        })
      }
    </div>
  );
};

export default PlanPicker;
